import { cn } from "../../lib/utils"

const Input = ({ className, type, ...props }: React.InputHTMLAttributes<HTMLInputElement>) => (
  <input
    type={type}
    className={cn(
      "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  />
)

export { Input }
